import { Link } from "react-router-dom";

interface Props {
  to: string;
}

const EditButton: React.FC<Props> = ({ to }) => {
  return (
    <Link to={to}>
      <button className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-2 px-4 rounded inline-flex items-center mb-4">
        <span className="text-2xl mr-2">✍️</span>Edit
      </button>
    </Link>
  );
};

export default EditButton;
